import type { IconSvgObject } from './types';

const ScreenRotationIcon: IconSvgObject = [
  ["path", { d: "M2.02769 12C2.02769 12 1.03077 22 11 22L10.0031 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.9723 12C21.9723 12 22.9692 2 13 2L13.9969 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11.6607 6.06066C11.0749 5.47487 10.1251 5.47487 9.53934 6.06066L6.06066 9.53934C5.47487 10.1251 5.47487 11.0749 6.06066 11.6607L12.3393 17.9393C12.9251 18.5251 13.8749 18.5251 14.4607 17.9393L17.9393 14.4607C18.5251 13.8749 18.5251 12.9251 17.9393 12.3393L11.6607 6.06066Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ScreenRotationIcon;
